module.exports = __webpack_public_path__ + "img/settings_grey.ee6161b9.svg";